var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headReward)?_c('div',{staticClass:"group-head-reward"},[_c('group-activity-section',{attrs:{"title":"团长奖励"}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.replaceString(_vm.headReward))}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }